/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Modals\ModalConfirmation\ModalConfirmation.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Monday June 26th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday, 5th October 2023 12:54:08
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { MouseEventHandler } from 'react';
import MyModal from "Content/Modals/MyModal";
import translator from 'MultiLanguage/TranslationWrapper';
import styles from "Content/Modals/ModalConfirmation/ModalConfirmation.module.css";

type ModalConfirmationProps = {
    show: boolean,
    onClose: MouseEventHandler<HTMLDivElement>,
    closeModal: MouseEventHandler,
    isOkay: boolean,
    additionnalMessage?: string | string[]
};

function ModalConfirmation(props: ModalConfirmationProps) {
    return (
        <MyModal addCloseCross={true} closeModal={props.closeModal} show={props.show} onClose={props.isOkay ? props.onClose: () => {}} footer={(()=>{return (<></>)})()} title={""} className={styles.modalCtaStyle} >
            <div className={`${styles.modal}`}>
                {
                    props.isOkay ?
                    <div> {translator.decode("modal.requestSend")}</div>
                    :
                    <div className={`${styles.errorDisplay}`}>
                        {translator.decode("modal.requestFail")}<br/>
                        <button className="btn btn-danger mt-3" onClick={props.closeModal}>{translator.decode("modal.close")}</button>
                    </div>
                }
                {
                    props.additionnalMessage ?
                    <div>{typeof(props.additionnalMessage) === "string" ? <p>{props.additionnalMessage}</p> : <><p>{props.additionnalMessage.map((mes) => <span key={Math.random()}><span>{mes}</span><br/></span>)}</p></>}</div>
                    : null
                }
            </div>
        </MyModal>
    )
}

export default ModalConfirmation;
